import { render } from "./ManageAccounts.vue?vue&type=template&id=0fb2145e&scoped=true"
import script from "./ManageAccounts.vue?vue&type=script&lang=js"
export * from "./ManageAccounts.vue?vue&type=script&lang=js"

import "./ManageAccounts.vue?vue&type=style&index=0&id=0fb2145e&lang=scss&scoped=true"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb2145e"]])

export default __exports__